// const kit = [
//   {
//     id: 'RRDS88F119-01',
//     desc: 'Airfield Operations Logistics and Sustainment Support System',
//     price: '$2,859,023.13',
//   },
//   {
//     id: 'RRDS88P557-01',
//     desc: 'Airfield Operations Support System',
//     price: '$5,416,916.87',
//   },
//   {
//     id: 'RRDS88F119-01-TC',
//     desc: 'Airfield Operations Logistics and Sustainment Support System Training and Commissioning',
//     price: '$54,399.07',
//   },
//   {
//     id: 'RRDS88P557-01-TC',
//     desc: 'Airfield Operations Support System Training and Commissioning',
//     price: '$167,080.74',
//   },
//   {
//     id: 'RRDS-HEC-KIT',
//     desc: 'Heavy Equipment Crane Kit',
//     price: '$7,021,640.96',
//   },
//   {
//     id: 'RRDS-MGS-KIT',
//     desc: 'Mobile Surveillance Kit',
//     price: '$2,900,000.00',
//   },
//   {
//     id: 'RRDS88F119-01',
//     desc: 'Airfield Operations Logistics and Sustainment Support System',
//     price: '$2,859,023.13',
//   },
//   {
//     id: 'RRDS88P557-01',
//     desc: 'Airfield Operations Support System',
//     price: '$5,416,916.87',
//   },
//   {
//     id: 'RRDS88F119-01-TC',
//     desc: 'Airfield Operations Logistics and Sustainment Support System Training and Commissioning',
//     price: '$54,399.07',
//   },
//   {
//     id: 'RRDS88P557-01-TC',
//     desc: 'Airfield Operations Support System Training and Commissioning',
//     price: '$167,080.74',
//   },
//   {
//     id: 'RRDS-HEC-KIT',
//     desc: 'Heavy Equipment Crane Kit',
//     price: '$7,021,640.96',
//   },
//   {
//     id: 'RRDS-MGS-KIT',
//     desc: 'Mobile Surveillance Kit',
//     price: '$2,900,000.00',
//   },
// ];

const kit = [
  {
    id: 'V-MANTIS-BK-F2',
    desc: 'Mantis Concealable Vest, NIJ level II Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$630.00',
  },
  {
    id: 'V-MANTIS-BK-F3A',
    desc: 'Mantis Concealable Vest, NIJ level IIIA Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$670.00',
  },
  {
    id: 'V-MANTIS-BK-I2',
    desc: 'Mantis Concealable Vest, Impedor Series level II Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$690.00',
  },
  {
    id: 'V-MANTIS-BK-I3A',
    desc: 'Mantis Concealable Vest, Impedor Series level IIIA Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$750.00',
  },
  {
    id: 'V-INTAC-BK-F2',
    desc: 'InTac Basic Tactical Vest, NIJ level II Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$730.00',
  },
  {
    id: 'V-INTAC-BK-F3A',
    desc: 'InTac Basic Tactical Vest, NIJ level IIIA Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$790.00',
  },
  {
    id: 'V-INTAC-BK-I2',
    desc: 'InTac Basic Tactical Vest, level II Impedor Series Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$770.00',
  },
  {
    id: 'V-INTAC-BK-I3A',
    desc: 'InTac Basic Tactical Vest, level IIIA Impedor Series Soft armor, Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$810.00',
  },
  {
    id: 'V-LVPC-COY-F3A',
    desc: 'Low-Viz Plate Carrier, w/NIJ level IIIA Soft armor (front/back), Coyote',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$670.00',
  },
  {
    id: 'V-LVPC-COY-I3A',
    desc: 'Low-Viz Plate Carrier, w/level IIIA Impedor Series Soft armor (front/back), Coyote',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$690.00',
  },
  {
    id: 'V-LVPC-COY-OS',
    desc: 'Low-Viz Plate Carrier, w/o soft armor, CARRIER OUTER SHELL ONLY, Coyote (armor NOT included)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$310.00',
  },
  {
    id: 'V-ECPC-BK-F3A',
    desc: 'Enhanced Coverage Plate Carrier (Scalable), w/level IIIA Fusion Series Soft armor (front/back/sides), Black (ballistic accessories like collar/throat, groin, biceps are optional)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$1250.00',
  },
  {
    id: 'V-ECPC-BK-I3A',
    desc: 'Enhanced Coverage Plate Carrier (Scalable), w/level IIIA Impedor Series Soft armor (front/back/sides), Black (ballistic accessories like collar/throat, groin, biceps are optional)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$1330.00',
  },
  {
    id: 'V-ECPC-BK-OS',
    desc: 'Enhanced Coverage Plate Carrier (Scalable), w/o soft armor, CARRIER OUTER SHELL ONLY, Black (armor NOT included, ballistic accessories like collar/throat, groin, biceps are optional)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$650.00',
  },
  {
    id: 'V-INTAC-PLAIN-BK-F3A',
    desc: 'InTac Plain Basic Tactical Vest (NO MOLLE), w/NIJ level IIIA Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$690.00',
  },
  {
    id: 'V-INTAC-PLAIN-BK-I3A',
    desc: 'InTac Plain Basic Tactical Vest (NO MOLLE), w/level IIIA Impedor Series Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$750.00',
  },
  {
    id: 'V-INTAC-PLAIN-BK-OS',
    desc: 'InTac Plain Basic Tactical Vest (NO MOLLE), CARRIER OUTER SHELL ONLY, Black (armor NOT included)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$330.00',
  },
  {
    id: 'V-SPC-BK-F2',
    desc: 'Slick Plus Plate Carrier (Scalable), w/level II Fusion Series Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$790.00',
  },
  {
    id: 'V-SPC-BK-I2',
    desc: 'Slick Plus Plate Carrier (Scalable), w/level II Impedor Series Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$810.00',
  },
  {
    id: 'V-SPC-BK-F3A',
    desc: 'Slick Plus Plate Carrier (Scalable), w/level IIIA Fusion Series Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$830.00',
  },
  {
    id: 'V-SPC-BK-I3A',
    desc: 'Slick Plus Plate Carrier (Scalable), w/level IIIA Impedor Series Soft armor (front/back/sides), Black',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$990.00',
  },
  {
    id: 'V-SPC-BK-OS',
    desc: 'Slick Plus Plate Carrier (Scalable), w/o soft armor, CARRIER OUTER SHELL ONLY, Black (armor NOT included)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$410.00',
  },
  {
    id: 'V-TFIRE-COY-F2',
    desc: 'First Responder Tactical Vest with High Viz Tape, w/level II Fusion Series Soft armor (front/back/sides), Coyote Brown, One Size Fits Most',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$910.00',
  },
  {
    id: 'V-TFIRE-COY-F3A',
    desc: 'First Responder Tactical Vest with High Viz Tape, w/level IIIA Fusion Series Soft armor (front/back/sides), Coyote Brown, One Size Fits Most',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$990.00',
  },
  {
    id: 'V-TFIRE-COY-I2',
    desc: 'First Responder Tactical Vest with High Viz Tape, w/level II Impedor Series Soft armor (front/back/sides), Coyote Brown, One Size Fits Most',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$990.00',
  },
  {
    id: 'V-TFIRE-COY-I3A',
    desc: 'First Responder Tactical Vest with High Viz Tape, w/level IIIA Impedor Series Soft armor (front/back/sides), Coyote Brown, One Size Fits Most',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$1,050.00',
  },
  {
    id: 'V-UOC-BK-OS',
    desc: 'Standard Uniform Outer Carrier, w/o soft armor, CARRIER OUTER SHELL ONLY, Black (armor NOT included)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$350.00',
  },
  {
    id: 'V-TUOC-BK-OS',
    desc: 'Tactical Uniform Outer Carrier, w/o soft armor, CARRIER OUTER SHELL ONLY, Black (armor NOT included)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$370.00',
  },
  {
    id: 'BP-1012-AFC-C4-BAP',
    desc: '10x12 Ballistic Plate, Shooters Cut, Stand-alone, Single-curve, Level IV, Nylon Cover Black, NIJ Model AFC-C4-BAP',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$270.00',
  },
  {
    id: 'BP-AFC3CE-1012-MC',
    desc: 'Ballistic Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 10x12, Shooters Cut, Multi-Curve, Model AFC-RF2-3CE',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$570.00',
  },
  {
    id: 'BP-AFC3CE-810-MC',
    desc: 'Ballistic Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 8x10, Shooters Cut, Multi-Curve, Model AFC-RF2-3CE',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$530.00',
  },
  {
    id: 'BP-AFC3CE-6X6-SC',
    desc: 'Side Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 6x6, Full Cut, Single-Curve, Model AFC-RF2-3CE',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$314.00',
  },
  {
    id: 'BP-AFC3CE-6X8-SC',
    desc: 'Side Plate, Level III+, NIJ 0101.06 Certified Plate, Stand-alone, 6x8, Full Cut, Single-Curve, Model AFC-RF2-3CE',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$324.00',
  },
  {
    id: 'BP-3403-SH-MC-L',
    desc: 'Ballistic Plate, Level III PE, NIJ 0101.06 Certified, Stand-alone, 10x12, Shooters Cut',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$790.00',
  },
  {
    id: 'BP-TAP-TP-SC-1012',
    desc: 'Ballistic Trauma Plate, Level IIIA, Special Threat Handgun Plate, Stand-alone, 10x12, Shooters Cut, Single-Curve',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$270.00',
  },
  {
    id: 'BP-TAP-TP-SC-810',
    desc: 'Ballistic Trauma Plate, Level IIIA, Special Threat Handgun Plate, Stand-alone, 8x10, Shooters Cut, Single-Curve',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$238.00',
  },
  {
    id: 'BP-TAP-TP-FC-7X9',
    desc: 'Ballistic Trauma Plate, Level IIIA, Special Threat Handgun Plate, Stand-alone, 7X9, Full Cut, Single-Curve',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$210.00',
  },
  {
    id: 'BP-TAP-TP-SC-5x8',
    desc: 'Ballistic Trauma Plate, Level IIIA, Special Threat Handgun Plate, Stand-alone, 5x8, Full Cut, Single-Curve',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$170.00',
  },
  {
    id: 'SAI-1012-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, 10"x12" Plate Backer (Shooters Cut, per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$174.00',
  },
  {
    id: 'SAI-ESAPI-XS-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, SAPI/ESAPI Size XS Plate Backer (per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$114.00',
  },
  {
    id: 'SAI-ESAPI-SM-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, SAPI/ESAPI Size SM Plate Backer (per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$124.00',
  },
  {
    id: 'SAI-ESAPI-MD-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, SAPI/ESAPI Size MD Plate Backer (per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$154.00',
  },
  {
    id: 'SAI-ESAPI-LG-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, SAPI/ESAPI Size LG Plate Backer (per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$178.00',
  },
  {
    id: 'SAI-ESAPI-XL-I3A',
    desc: 'Soft Armor Insert, NIJ Level IIIA Impedor Series, SAPI/ESAPI Size XL Plate Backer (per piece)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$196.00',
  },
  {
    id: 'SAI-MANTIS-F2',
    desc: 'Soft Armor Inserts, NIJ Level II Fusion Series, Standard Mantis Concealable Shape and Grade (per set front & back)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$510.00',
  },
  {
    id: 'SAI-MANTIS-F3A',
    desc: 'Soft Armor Inserts, NIJ Level IIIA Fusion Series, Standard Mantis Concealable Shape and Grade (per set front & back)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$550.00',
  },
  {
    id: 'SAI-MANTIS-I2',
    desc: 'Soft Armor Inserts, NIJ Level II Impedor Series, Standard Mantis Concealable Shape and Grade (per set front & back)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$570.00',
  },
  {
    id: 'SAI-MANTIS-I3A',
    desc: 'Soft Armor Inserts, NIJ Level IIIA Impedor Series, Standard Mantis Concealable Shape and Grade (per set front & back)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$630.00',
  },
  {
    id: 'SAI-SPEAR-F3A',
    desc: 'Soft Armor Inserts, NIJ Level IIIA, SPEAR/BALCS Shape and Grade (per set front & back)',
    manu: 'Applied Fiber Concepts, Inc.',
    price: '$790.00',
  },
];

const tableBody = document.querySelector('.table__kit tbody');

kit.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
